"use strict";

exports.__esModule = true;
exports.ClockFields = ClockFields;
var _core = require("@blueprintjs/core");
var _react = _interopRequireDefault(require("react"));
var _Translator = require("../../Core/Translator");
var _TimeFormatSelector = require("../../Time/TimeFormatSelector/TimeFormatSelector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var timeFormats = [{
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}, {
  hour: "2-digit",
  minute: "2-digit"
}];

/**
 * Fields for ClockElement.
 */
function ClockFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("ClockFields.timeFormat.label", "Time Format"),
      helperText: translate("ClockFields.timeFormat.helperText", "The time format to show in the clock.")
    }, /*#__PURE__*/_react["default"].createElement(_TimeFormatSelector.TimeFormatSelector, {
      selected: [element.props.timeFormat || timeFormats[0]],
      onSelect: function onSelect(_ref2) {
        var timeFormat = _ref2[0];
        return elementEditor.setProp(path, "timeFormat", timeFormat);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: element.props.showTimezone || false,
      label: translate("ClockFields.showTimezone.label", "Show Timezone"),
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "showTimezone", e.target.checked);
      }
    }));
  });
}